module.exports = __webpack_public_path__ + "static/media/youtube.848f02f3.svg";